import { defineComponent } from 'vue';
import { AchProviders } from '@/constants/payments';

export default defineComponent({
  computed: {
    achProvider(): AchProviders {
      return this.$store.getters['PaymentOptions/achProvider'];
    },

    isAchProviderCrb(): boolean {
      return this.achProvider === AchProviders.Crb;
    }
  }
});
